import { PageContainer } from '../../components/layout/PageContainer.tsx';
import { IssPasses } from './IssPasses.tsx';
import { SkyCard } from './SkyCard.tsx';

/** Détail du « ciel d'Ermont » : coucher de soleil, méthode, indices du quotidien, webcam. */
export function SkyPage() {
  return (
    <PageContainer path="/ciel">
      <SkyCard />
      <IssPasses />
    </PageContainer>
  );
}
